<template>
  <!-- <FiltroRecursosProprios> </FiltroRecursosProprios> -->
  <div>
    <unicom-tabela
      :exibirQtItensPagina="qtPaginas > 0"
      iconeMensagemVazia="search"
      mensagemVazia="Nenhum resultado encontrado"
      subtituloMensagemVazia="mostrar todos"
      mostrarNovoBlocoVazio
      alturaMinimaBody="260px"
      :alturaBody="300"
      :icones="[]"
      :itensPorPagina="['5', '10', '15', '20']"
      :itemSelecionadoProp="itemSelecionado"
      :pagina="pagina"
      :qtPaginas="qtPaginas"
      :qtResultados="qtResultados"
      :rows="rows"
      :cabecalho="cabecalho"
      :carregamento="loadingTabela"
      textoExibindo="Resultados"
      contemHover
      @click-subtitulo-mensagem="$refs.filtro.limpar()"
      @click-linha="clickLinha"
      @troca-pagina="trocarPagina"
      @troca-elemento-pagina="trocarElementoPagina"
      @ordena="ordenarColuna"
      class="header-personalizado"
    >
      <div slot="header">
        <unicom-linha espacamento :justificarItem="'end'">
          <unicom-coluna sm="12" md="auto" class="flex-fill">
            <unicom-barra-pesquisa-v2
              v-model="campoPesquisa"
              @limpar-campos="limparCampoPesquisa"
              @pesquisar="pesquisarTabela"
              placeholder="Busque por um CNPJ ou nome do prestador..."
            />
          </unicom-coluna>
          <unicom-coluna
            sm="12"
            md="auto"
            :class="$breakpoint.smAndDown ? 'mt-2' : ''"
          >
            <unicom-botao
              :bloco="$breakpoint.smAndDown"
              :largura="170"
              @click="mostrarFiltro = true"
              contornado
              nomeIcone="sliders"
              estiloIcone="transform: rotate(90deg);"
            >
              FILTRAR
              <div class="quantidade-filtro" v-if="quantidadeFiltro">
                {{ quantidadeFiltro }}
              </div>
            </unicom-botao>
          </unicom-coluna>
        </unicom-linha>
      </div>
    </unicom-tabela>
    <FiltroRecursosProprios
      ref="filtro"
      v-model="mostrarFiltro"
      :listaTipos="listaTipos"
      :listaRedes="listaRedes"
      :listaUnimedOrigem="listaUnimedOrigem"
      @unimed-limpada="limparUnimed = false"
      @limpar-filtro="limparFiltro"
      @limpar-pesquisa="limparPesquisa"
      @filtrar="filtrar"
      @filtroPuro="obj => (objetoFiltroPuro = obj)"
    ></FiltroRecursosProprios>
  </div>
</template>

<script>
import FiltroRecursosProprios from "./FiltroRecursosProprios.vue";
import RecursosPropriosMixin from "../RecursosProprios.mixin";

export default {
  mixins: [RecursosPropriosMixin],
  components: {
    FiltroRecursosProprios
  }
};
</script>
